import { styled, Box } from '@mui/material';

export const Wrapper = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
`;
